var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"micad_verticalText"},[_vm._v(" "+_vm._s(_vm.verticalText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }